"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rndBetween = exports.values = exports.keys = exports.entries = exports.assign = void 0;
// eslint-disable-next-line id-match
var assign = Object.assign,
    entries = Object.entries,
    keys = Object.keys,
    values = Object.values; // eslint-disable-next-line id-match

exports.values = values;
exports.keys = keys;
exports.entries = entries;
exports.assign = assign;
var floor = Math.floor,
    random = Math.random; // eslint-disable-next-line no-magic-numbers

var rndBetween = function rndBetween() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
  return floor(random() * (to - from + 1)) + from;
};

exports.rndBetween = rndBetween;